type LogLevel = "info" | "warn" | "error" | "debug" | "log";

class Logger {
  private static instance: Logger;
  private isDevelopment: boolean;

  private constructor() {
    this.isDevelopment = process.env.NODE_ENV === "development";
  }

  public static getInstance(): Logger {
    if (!Logger.instance) {
      Logger.instance = new Logger();
    }
    return Logger.instance;
  }

  // Convert the error levels to log as production environment only takes in logger.log level
  // TODO: Only log using console.log in production environment
  private formatMessage(level: LogLevel, message: string): string {
    const timestamp = new Date().toISOString();
    const prefix = `[${timestamp}] [${level.toUpperCase()}]`;
    return `${prefix} ${message}`;
  }

  public info(message: string, ...args: unknown[]): void {
    const formattedMessage = this.formatMessage("info", message);
    if (this.isDevelopment) {
      console.info(formattedMessage, ...args);
    } else {
      // In production, we use console.log to ensure it's not stripped
      console.log(formattedMessage, ...args);
    }
  }

  public warn(message: string, ...args: unknown[]): void {
    const formattedMessage = this.formatMessage("warn", message);
    if (this.isDevelopment) {
      console.warn(formattedMessage, ...args);
    } else {
      console.log(formattedMessage, ...args);
    }
  }

  public error(message: string, ...args: unknown[]): void {
    const formattedMessage = this.formatMessage("error", message);
    if (this.isDevelopment) {
      console.error(formattedMessage, ...args);
    } else {
      console.log(formattedMessage, ...args);
    }
  }

  public debug(message: string, ...args: unknown[]): void {
    if (this.isDevelopment) {
      const formattedMessage = this.formatMessage("debug", message);
      console.debug(formattedMessage, ...args);
    }
  }

  public log(message: string, ...args: unknown[]): void {
    const formattedMessage = this.formatMessage("log", message);
    console.log(formattedMessage, ...args);
  }
}

export const logger = Logger.getInstance();
